import React, { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';

import { ReactComponent as CloseIcon } from '@/assets/icons/close-icon.svg';
import { ReactComponent as PhenomIcon } from '@/assets/logo-icon.svg';
import { ReactComponent as CheckVerified } from '@/assets/icons/check-verified.svg';

import styles from './AddToHomeScreen.module.css';
import { ShareIcon } from 'lucide-react';

const getBrowserName = () => {
  const userAgent = navigator.userAgent;
  console.log(navigator);
  if (userAgent.includes('CriOS')) {
    return 'ChromeIOS';
  } else if (userAgent.includes('Chrome')) {
    return 'Chrome';
  } else if (userAgent.includes('Safari')) {
    return 'Safari';
  } else if (userAgent.includes('Firefox')) {
    return 'Firefox';
  } else if (userAgent.includes('Edge')) {
    return 'Edge';
  } else {
    return 'Unknown';
  }
};
const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const AddToHomeScreen: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [modalPreviouslyClosed, setModalPreviouslyClosed] = useState(false);

  useEffect(() => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const modalWasClosed = localStorage.getItem('addToHomeScreenModalClosed') === 'true';

    if (!isStandalone && !modalWasClosed) {
      setOpen(true);
    }

    setModalPreviouslyClosed(modalWasClosed);
  }, []);

  const handleOnClose = () => {
    setOpen(false);
    localStorage.setItem('addToHomeScreenModalClosed', 'true');
  };

  const browserName = getBrowserName();

  if (modalPreviouslyClosed || !isMobileDevice()) {
    return null;
  }
  return (
    <Dialog
      transition
      open={open}
      onClose={() => {
        console.log(close);
      }}
    >
      <DialogBackdrop transition className="fixed inset-0 bg-black/30 duration-300 ease-out data-[closed]:opacity-0" />
      <DialogPanel
        transition
        className={twMerge(
          styles.addToHomeScreen,
          'rounded-t-[30px] border-ph-white/10 bg-ph-background-dark text-white duration-300 ease-out',
        )}
      >
        <div className="flex flex-col gap-4 rounded-t-[30px] bg-radial-purple-big p-8">
          <div className="flex flex-col">
            <div className="absolute right-4 top-4 flex w-full justify-end">
              <CloseIcon onClick={handleOnClose} className="text-white" />
            </div>
            <div className="flex h-18 w-18 items-center justify-center rounded-[20px] bg-ph-background-dark">
              <PhenomIcon className="h-9 w-9" />
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-bold">The Best Phenom Experience</h2>
            </div>
            <p className="text-sm text-ph-white-50">
              Add the Phenom Poker App to your home screen to enjoy the following benefits:
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <span className="flex gap-3 text-sm font-bold">
              <CheckVerified /> Quick Access
            </span>
            <span className="flex gap-3 text-sm font-bold">
              <CheckVerified /> Better User Experience
            </span>
            <span className="flex gap-3 text-sm font-bold">
              <CheckVerified /> Improved Performance
            </span>
          </div>
          {browserName === 'Safari' ? (
            <div className="flex flex-col gap-1">
              <h3 className="text-base font-bold">Add to Home Screen</h3>
              <p className="text-sm">
                In you {browserName} browser menu, tap the{' '}
                <span className="inline-flex gap-1 font-bold">
                  Share
                  <ShareIcon className="h-4 w-4" />
                </span>{' '}
                icon and choose <span className="font-bold">Add to Home Screen</span> in the options. Then open the
                Phenom Poker app on your home screen
              </p>
            </div>
          ) : browserName === 'Chrome' || browserName === 'Edge' || browserName === 'Firefox' ? (
            <div className="flex flex-col gap-1">
              <h3 className="text-base font-bold">Add to Home Screen</h3>
              <p className="text-sm">
                In your {browserName} browser, click the <span className="inline-flex gap-1 font-bold">Menu</span>{' '}
                button. Select <span className="font-bold">Install</span> or{' '}
                <span className="font-bold">Install Phenom Poker</span> from the menu, and click{' '}
                <span className="font-bold">Install</span> in the confirmation dialog. Then open the Phenom Poker app
                from your home screen.
              </p>
            </div>
          ) : browserName === 'ChromeIOS' ? (
            <div className="flex flex-col gap-1">
              <h3 className="text-base font-bold">Add to Home Screen</h3>
              <p className="text-sm">To add this app to your home screen please open it on Safari</p>
            </div>
          ) : (
            <p className="text-sm">The "Add to Home Screen" feature is not supported in your browser.</p>
          )}
        </div>
      </DialogPanel>
    </Dialog>
  );
};

export default AddToHomeScreen;
